import React, { createContext, useState } from 'react';

// Create a context
export const TitleContext = createContext();

// Create a provider component
export const TitleProvider = ({ children }) => {
  const [title, setTitle] = useState(''); // Set a default title if needed

  return (
    <TitleContext.Provider value={{ title, setTitle }}>
      {children}
    </TitleContext.Provider>
  );
};
